import MaintainerListView from '../../components/MaintainerListView';

MaintainerListScreen.propTypes = {};

function MaintainerListScreen(props) {
    // MARK: ---- PROPERTIES ----

    return (
        <div>
            <div className="my-4">
                <MaintainerListView />
            </div>
        </div>
    );
}

export default MaintainerListScreen;
